import {getFormData} from '../../../utilities/helper/formDataConvertor';
import request from '../../axios';

export const getShopTypes = async () => {
  const {data}: {data: Array<IShopType>} = await request.get(
    `/api/v2/store/store-type-list`,
  );
  return data;
};

export const createUserShop = async (payload: ICreateShopPayload) => {
  const {data}: {data: IResponse} = await request.post(
    `/api/v2/store/store-info`,
    getFormData(payload as unknown as {[name: string]: string | Blob}),
    {headers: {'content-type': 'multipart/form-data'}},
  );
  return data;
};

export const editUserShop = async (payload: ICreateShopPayload) => {
  const {data}: {data: IResponse} = await request.put(
    `/api/v2/store/store-info`,
    getFormData(payload as unknown as {[name: string]: string | Blob}),
    {headers: {'content-type': 'multipart/form-data'}},
  );
  return data;
};

export const createUserLabShop = async (payload: ICreateShopPayload) => {
  const {data}: {data: IResponse} = await request.post(
    `/api/v2/store/lab-post`,
    getFormData(payload as unknown as {[name: string]: string | Blob}),
    {headers: {'content-type': 'multipart/form-data'}},
  );
  return data;
};
export const updateUserLabShop = async (payload: ICreateShopPayload) => {
  const {data}: {data: IResponse} = await request.put(
    `/api/v2/store/lab-post`,
    getFormData(payload as unknown as {[name: string]: string | Blob}),
    {headers: {'content-type': 'multipart/form-data'}},
  );
  return data;
};
